import { Injectable } from '@angular/core';
import { ServiceResult } from './service-result.model';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  public getSuccessResponseMessages(response: ServiceResult<any>[]) {
    const result = [];

    if (response && response.length > 0) {
      response.forEach(r => {
        if (!!r && 'warnings' in r) {
          r.warnings.forEach(w => {
            result.push(w);
          });
        }
      });
    }

    return result;
  }

  public getErrorResponseMessages(response: HttpErrorResponse) {
    const result = [];

    if (response?.error) {
      response.error.forEach(e => {
        if (Array.isArray(e)) {
          e.forEach(m => {
            result.push(m);
          });
        }
      });
      if (response.error.developerMessage?.exception?.message?.length) {
        result.push(this.getErrorMessageObject(response.error.developerMessage.exception.message));
      }
    }

    return result;
  }

  private getErrorMessageObject = (message: string, type: string = 'Exception') => ({
    type,
    message,
  });
}
